'use client';
const getRootShadowHost = (node)=>{
    let shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
};

export { getRootShadowHost };
//# sourceMappingURL=getRootShadowHost.js.map
